uniform float time;
uniform bool  fadeSet;
uniform float fadeStart;
varying vec2  vUv;

void main() {
    vec3 baseColor = vec3(0.3, 0.5, 1.0);
    vec3 color;  
    float alpha = 0.2;

    if (fadeSet) {
      float fade = smoothstep(1.0, fadeStart, vUv.y);
      alpha *= fade;
      color = baseColor;  
    } else {
      float stripes = sin((vUv.x + time * 0.5) * 10.0);
      float glow    = smoothstep(0.25, 0.3, stripes)
                    - smoothstep(0.3,  0.35, stripes);
      glow *= 0.8;
      vec3 glowColor = vec3(1.0);
      color = mix(baseColor, glowColor, glow);
    }
    gl_FragColor = vec4(color, alpha);
}

